import { WiseOwlUser } from "./user";
import { ValueOf } from "./utility";
import { WiseOwlIngress } from "./wiseOwlApi";

export type PreEngagementData = {
  question: string;
  friendlyName: string;
  email: string;
  productCategory: string;
  url: string;
  userSid: string;
  accountSid: string;
  identity: string;
  metadata: string;
  location: string;
};

export type LiveChatCreateArgs = {
  chatFriendlyName: string;
  customerFriendlyName: string;
  preEngagementData: PreEngagementData;
};

export type LiveChatRefreshTokenArgs = {
  identity: string;
};

export type LiveChatCreateResponseData = {
  liveChatId: string;
  token: string;
  identity: string;
  chatActivitySyncMapId: string;
};

export type LiveChatRefreshTokenResponseData = {
  token: string;
};

export interface HelpCenterApiResponse<Type> {
  data: Type;
  message: string;
  statusCode: number;
  success: boolean;
}

export const LiveChatPhaseEnum = {
  Waiting: "waiting",
  Active: "active",
  Ended: "ended",
} as const;
export type LiveChatPhaseEnumType = ValueOf<typeof LiveChatPhaseEnum>;

export interface HelpCenterApiArgs {
  ingress?: WiseOwlIngress;
  token?: string;
  user?: WiseOwlUser;
}
